import { render, staticRenderFns } from "./BadgeContextual.vue?vue&type=template&id=a520f58e&"
import script from "./BadgeContextual.vue?vue&type=script&lang=js&"
export * from "./BadgeContextual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports